import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export const getUserActions = actionCreator.async<any, { user: any }, any>('GET_USER');
export const updateUserActions = actionCreator.async<any, { user: any }, any>('UPDATE_USER');
